export const QUESTION_INPUT_OPTION = [
  {
    name: '객관식(단일)',
    value: 'SINGLE_CHOICE',
  },
  {
    name: '객관식(복수)',
    value: 'MULTIPLE_CHOICE',
  },
  {
    name: '선형배율',
    value: 'LINEAR_SCALE',
  },
  {
    name: '주관식',
    value: 'TEXT',
  },
] as const;

export type QuestionType = 'additional' | 'feedback';

export type InputType = (typeof QUESTION_INPUT_OPTION)[number]['value'];

export interface IQuestion {
  id: number;
  type: InputType;
  title: string;
  description: string;
  options?: IQuestionOption[];
  isRequired?: boolean;
}

export interface IQuestionOption {
  id: number;
  value: string;
  subValue?: string;
}
